// extracted by mini-css-extract-plugin
export default {"imagebg":"birdhouse_imagebg__syaOT"};